// extracted by mini-css-extract-plugin
export default {"sectionHeader":"daodao-brand-footer-SectionTitle__sectionHeader--2RqZk"};